module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/transliteration#tra"
    }
  }, [_vm._v("Note on Transliteration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Competing Calls in Urban Morocco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Nationalizing the Call: Trance, Technology, and Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Our Master’s Call: The Apotheosis of Moroccan Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Summoning in Secret: Mute Letters and Veiled Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Rites of Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Trance-Nationalism, or, the Call of Moroccan Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" “To Eliminate the Ghostly Element Between People”: The Call as Exorcism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/references#ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0